import actions from './actions';
import mutations from './mutations';

// state initial values
const state = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
